import { ICombineMode } from './types';

// 两种模式
// path: suffix 拼接在路径上面 https://dev.pandateacher.com/biz/passport-feat-analyze/
// domain: 忽略suffix
export const combineMode: ICombineMode = 'path'
